<template>
  <v-img
    :src="src"
    lazy-src=""
    aspect-ratio="1"
    class="grey lighten-4"
    max-width="300"
    max-height="200"
  >
    <template v-slot:placeholder>
      <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
      >

        <div class="pa-2">
          Network Needed for Image
        </div>
        <v-progress-circular indeterminate color="red darken-3"></v-progress-circular>
      </v-row>
    </template>
  </v-img>

</template>
<script>
export default {
  name: 'ImagePlaceholder',
  props: ['src'],
  data() {
    return {
      imageSrc: this.src
    }
  },
  watch: {
    src() {
      this.imgeSrc = this.src
    }
  }
}


</script>
